import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withLocalize } from 'react-localize-redux';
import { get } from 'lodash';
import { Loyalty } from '@material-ui/icons';
import './SoothePassPromotion.css';

class SoothePassPromotion extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }

  render() {
    const isSoothePassSubscribed = get(this.props, 'booking.cart.info_fields.soothe_pass.subscribed', false) || get(this.props, 'client.soothe_pass.soothe_pass_subscribed', false);
    const isSoothePassAvailable = get(this.props, 'client.soothe_pass.soothe_pass_available', false);
    const loggedIn = get(this.props, 'client.loggedIn', false);
    const { has_discount, service_text } = get(this.props, 'client.soothe_pass.discount', {});
    const alreadyAppliedToCart = get(this.props, 'booking.cart.info_fields.soothe_pass.subscription_applied_to_cart', false);
    // Don't show if user is subscribed, SoothePass not available, or not logged in
    if (isSoothePassSubscribed || !isSoothePassAvailable || !loggedIn || alreadyAppliedToCart) {
      return null;
    }
    if(has_discount){
    return (
      <div 
        className="soothepass-promotion clickable" 
        onClick={() => {
          if (this.props.openPlanPopup) {
            this.props.openPlanPopup();
          }
        }}
        role="button"
        tabIndex={0}
        onKeyPress={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            if (this.props.openPlanPopup) {
              this.props.openPlanPopup();
            }
          }
        }}
      >
        <div className="promotion-content">
          <div className="promotion-header">
            <div className="promotion-icon">
              <Loyalty style={{ fontSize: '18px', color: '#F58266' }} />
            </div>
            <div className="promotion-text">
              <span className="promotion-title">New to SoothePass™? </span>
            </div>
          </div>
          <div className="promotion-description">
            {service_text}
          </div>
        </div>
      </div>
    );
    }
    return null;
  }
}

const mapStateToProps = (state) => ({
  booking: state.booking,
  client: state.client,
});

SoothePassPromotion.propTypes = {
  booking: PropTypes.object.isRequired,
  client: PropTypes.object.isRequired,
  openPlanPopup: PropTypes.func,
};

export default withLocalize(connect(mapStateToProps)(SoothePassPromotion));





